import styled from "styled-components";

export const MetricCellStyled = styled.div`
  padding: 0 6px;
  line-height: 1.45;
  display: flex;
  align-items: center;
  gap: 8px;
  .metric_label {
    padding-right: 40px;
    font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
    color: ${({ theme }) => theme.COLORS.GRAY_26};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
  }

  .metric_value {
    font-family: ${({ theme }) => theme.FONT.STYLE.BOLD};
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
  }
`;
